<template>

    <div>
        <section id="knowledge-base-search">
            <b-card
                no-body
                class="knowledge-base-bg text-center"
                :style="{backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,backgroundAttachment: 'fixed'}"
            >
                <b-card-body class="card-body">
                    <h2 class="text-primary">
                        {{ penerimaan.no_terima  }}
                    </h2>
                    <b-card-text class="mb-2">

                        Rincian Penerimaan
                        <!--                        <span>Popular searches: </span>
                                                <span class="font-weight-bolder">Sales automation, Email marketing</span>-->
                    </b-card-text>
                    <!-- form -->
                </b-card-body>
            </b-card>
        </section>
        <add-new-rincian
            :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
            @refetch-data="refetchData"
        />

        <!-- Table Container Card -->
        <b-card
            no-body
            class="mb-0"
        >

            <div class="m-2">

                <!-- Table Top -->
                <b-row>

                    <!-- Per Page -->
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                        <label>Show</label>
                        <v-select
                            v-model="perPage"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block mx-50"
                        />
                        <label>entries</label>
                    </b-col>

                    <!-- Search -->
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-on:input="debounceInput"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="isAddNewUserSidebarActive = true"
                            >
                                <span class="text-nowrap">Add Rincian Penerimaan</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>

            </div>
            <b-overlay
                spinner-variant="primary"
                id="overlay-background"
                :show="loadTable"
                variant="transparent"
                opacity="1.00"
                blur="0.5em"
                rounded="sm"
            >
                <b-table
                    :busy.sync="loadTable"
                    ref="refUserListTable"
                    class="position-relative"
                    :items="(fetch) ? fetch : fetchPenerimaanRincians"
                    responsive
                    :fields="tableColumns"
                    primary-key="id"
                    :sort-by.sync="sortBy"
                    show-empty
                    :sort-desc.sync="isSortDirDesc"
                    :hover="true"
                >
                    <template #cell(kd_produk)="data">
                        <b-media vertical-align="center">
                            <b-link
                                :to="{ name: 'apps-produk-view', params: { id: data.item.kd_produk } }"
                                class="font-weight-bold d-block text-nowrap"
                            >
                                {{ data.item.kd_produk }}
                            </b-link>
                        </b-media>
                    </template>
                    <template #cell(catatan)="data">
                        {{ (data.value) ? data.value : '-' }}
                    </template>
                    <template #cell(actions)="data">
                        <b-link @click="onDestroy(data.item.id,data.item.kd_produk)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Delete </span>
                        </b-link>
                    </template>

                </b-table>
            </b-overlay>
            <div class="mx-2 mb-2">
                <b-row>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >

                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalUsers"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>

                    </b-col>

                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import router from '@/router'

import { ref, onUnmounted } from '@vue/composition-api'
import ListFilters from './ListFilters.vue'
import useRincianPenerimaanList from './useRincianPenerimaanList'
import penerimaanStoreModule from './penerimaanStoreModule'
import AddNewRincian from './AddNewRincian'

export default {
    components: {
        DatePicker  : () => import('vue2-datepicker'),
        ListFilters,
        AddNewRincian,
        BOverlay,
        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,

        vSelect,
    },
    methods: {
        debounceInput: _.debounce(function (e) {
            this.searchQuery = e
        }, 500)
    },
    props: {
        id_penerimaan: {
            required: false,
        },
        fetch: {
            required: false,
        }
    },
    setup(props,{ emit }) {
        const USER_APP_STORE_MODULE_NAME = 'app-penerimaan'
        const penerimaan = ref([]);
        // Register module
        if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, penerimaanStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
        })
        store.dispatch('app-penerimaan/fetchPenerimaan', router.currentRoute.params.id).then((response) => {
            penerimaan.value = response.data
        })

        const isAddNewUserSidebarActive = ref(false)

        const {
            fetchPenerimaanRincians,
            tableColumns,
            perPage,
            currentPage,
            totalUsers,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,

        } = useRincianPenerimaanList((props.id_penerimaan) ? props.id_penerimaan : router.currentRoute.params.id)

        const onDestroy = (id, name = '') => {
            confirm(`Delete ${name} ?`) ?
            store.dispatch('app-penerimaan/deleteRincianPenerimaan', id).then(() => {
                refetchData()
            }) : false;
        }
        return {
            props,
            onDestroy,
            // Sidebar
            loadTable: false,
            isAddNewUserSidebarActive,

            fetchPenerimaanRincians,
            tableColumns,
            perPage,
            currentPage,
            totalUsers,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
            penerimaan
        }
    },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
    width: 90px;
}
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
